import React, { VFC } from 'react';
import { useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Layout } from '../../components/Layout/Layout';
import { MeterDetailContent } from './components/Content';
import { MeterDetailFooter } from './components/Footer';
import { MeterContext } from '../../contexts/Meter';
import { MeterDetailPage as messages } from './messages';
import { useContextMeter } from '../../hooks/useContextMeter';

export const MeterDetailPage: VFC = () => {
  const { id } = useParams();
  const inventoryMeterId = parseInt(id ?? '');
  const { enmonMeter, inventoryMeter, isLoading } = useContextMeter(inventoryMeterId);

  const contextValue = React.useMemo(
    () => ({ enmonMeter, inventoryMeter, isLoading }),
    [enmonMeter, inventoryMeter, isLoading],
  );

  return (
    <MeterContext.Provider value={contextValue}>
      <Layout footerContent={<MeterDetailFooter />} headerContent={<FormattedMessage {...messages.meterDetail} />}>
        <MeterDetailContent />
      </Layout>
    </MeterContext.Provider>
  );
};
